export default "__VITE_ASSET__3c6ea826__"